/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines-per-function */
import React, {useRef, useState, useEffect} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import cx from 'classnames';
import {v4} from 'uuid';
import {isPreview} from '~/ViewInvitation/utils';
import {Card} from '~/common/canvas/Card/Card';
import {isFabric} from '~/common/utils/event_utils';
import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {GoogleAdBanner} from '~/common/fabric/GoogleAds/GoogleAdBanner';
import {selectIsHostViewing} from '~/common/fabric/reducers/eviteEvent/selectors';
import {selectIsHost} from '~/common/fabric/User/reducers/user';
import {useIsMediumAndUp, useIsLargeAndUp} from '~library/hooks/useMatchQuery';
import {Typography} from '~library/atoms/Typography';
import {FreeEventCountdown} from '~/ViewInvitation/common/FreeEventCountdown';
import {cityAddressLine, convertToIso, dateTimesWithCurrentYear} from '~/create/utils/formatters';
import {CustomLogoImage} from '~/create/components/CustomLogo/CusomLogoImage';
import {useFitContainer} from '~/ViewInvitation/common/useFitContainer';
import {PremiumCarousel} from './Premium/PremiumCarousel';

const SIDEPANEL_AD_ID = v4();

const ViewCoverMobile = (props) => {
  const {
    event,
    template: snakeTemplate,
    customImageURL,
    isPremium,
    fabricArt,
    showPremiumWebview,
    isWebview,
    isViewInvitationPage,
    onCanPlayAnimation,
    toggleUpsellModal,
  } = props;

  const template = {
    assets: snakeTemplate?.assets,
    uyo: snakeTemplate?.uyo,
    designTypeName: snakeTemplate?.design_type_name,
    eventTitleColor: snakeTemplate?.event_title_color,
    informationColor: snakeTemplate?.information_color,
    specialFeatures: snakeTemplate?.special_features,
    mobileImage: snakeTemplate?.assets?.mobileImage,
    css: snakeTemplate?.assets?.custom_css,
    customFonts: snakeTemplate?.custom_fonts,
    type: snakeTemplate?.type,
  };

  // UYO - handles cropped user images for free mobile

  let uyoImageElement = null;

  if (template.uyo)
    uyoImageElement = (
      <img id="main_image" src={customImageURL} alt="" className={template.designTypeName} />
    );

  const {scale, ref: fitContainerRef} = useFitContainer({});

  const [designHeight, setDesignHeight] = useState('0');
  const designTemplateRef = useRef(null);
  const {start_formatted: startFormatted, end_formatted: endFormatted} =
    dateTimesWithCurrentYear(event);

  const searchParams = new URLSearchParams(window.location.search);
  const isGuestPreview = !!searchParams.get('preview');

  const eventImageStyle = {};
  // TODO do we need this?
  if (template.designType && event.options.custom_image_id)
    eventImageStyle.background = 'transparent';

  const isMediumAndUp = useIsMediumAndUp();
  const isLargeAndUp = useIsLargeAndUp();
  const [design, setDesign] = useState('');

  const getFallbackImageUrl = () => {
    if (isPremium) {
      return template.assets.thumb_slider;
    }
    if (isMediumAndUp) {
      return template.assets.backgroundImage;
    }
    if (
      template.assets.mobileImage_special_features &&
      template.specialFeatures &&
      template.specialFeatures.countdown
    ) {
      return template.assets.mobileImage_special_features;
    }
    return template.assets.mobileImage || template.mobileImage || template.assets.thumb_slider;
  };

  const getRenderedPremiumImageUrl = async () => {
    if (!isPremium && !isMediumAndUp) {
      setDesign(getFallbackImageUrl());
      return;
    }

    const eventId = event.id;
    const response = await evite.fetch(`/plus/create/${eventId}/rendered-image-url/`);
    if (!response.ok) {
      if (event.options.rendered_image_url) {
        setDesign(event.options.rendered_image_url);
      } else {
        setDesign(getFallbackImageUrl());
      }
      return;
    }

    const json = await response.json();

    if (json.rendered_image_url) {
      setDesign(json.rendered_image_url);
    } else if (event.options.rendered_image_url) {
      setDesign(event.options.rendered_image_url);
    } else {
      setDesign(getFallbackImageUrl());
    }
  };

  useEffect(() => {
    if (event.origin !== 21) {
      getRenderedPremiumImageUrl()
        .then(() => evite.log('Premium image url rendered.'))
        .catch((e) => evite.error(`Error ${e} when rendering premium image url`));
    }
  }, [isMediumAndUp]);

  useEffect(() => {
    const distFromTop = designTemplateRef.current.getBoundingClientRect().top;
    const theHeight = `${window.innerHeight - distFromTop}px`;
    setDesignHeight(theHeight);
  }, []);

  // calculate number of visible lines
  let lineCount = 2;
  for (const item of [
    event.phone_number,
    event.end_datetime,
    event.location_name,
    event.street_address,
    event.city || event.state || event.zip_code,
    event.title && event.title.length > 16,
  ])
    if (item) lineCount += 1;

  const showCustomLogo = event.custom_logo && event.custom_logo?.url;
  const logoHasBeenPaid = Boolean(
    window.cover_data?.custom_logo && window.cover_data.custom_logo?.url
  );

  let logoImgProps = {};
  if (showCustomLogo && logoHasBeenPaid) {
    logoImgProps = {
      custom_logo: event.custom_logo,
      layout: 'mobile',
      zIndex: 200,
      clickable: false,
    };
  }
  const isHostViewing = useSelector(selectIsHostViewing);
  const isHost = useSelector(selectIsHost);
  const isCreateEditPreview = !!isPreview();
  const isRealViewInvitation = !isCreateEditPreview && !isGuestPreview;
  const showSidePanel = !isPremium && isLargeAndUp && (isGuestPreview || isRealViewInvitation);

  return (
    <div
      className={`view-invitation__design-template ${template.type || ''}`}
      ref={designTemplateRef}
      id="designTemplate"
    >
      {fabricArt &&
        fabricArt.objects &&
        window.fonts &&
        fabricArt.objects.map((o, index) => {
          if (o.type !== 'textbox') return null;
          const font = window.fonts.find(
            (f) => f.family === o.fontFamily && f.weight === o.fontWeight
          );
          if (font) {
            return (
              <link
                rel="stylesheet"
                href={font.url}
                key={`${o.fontFamily || font.family}_${o.fontWeight || font.weight}-${index}`}
              />
            );
          }
          return undefined;
        })}
      {showPremiumWebview ? (
        <PremiumCarousel
          isWebview={isWebview}
          height={designTemplateRef.current?.style?.height || designHeight}
          designTemplateRef={designTemplateRef}
          preview={false}
          fabricArt={fabricArt}
          isViewInvitationPage={isViewInvitationPage}
          onCanPlayAnimation={onCanPlayAnimation}
        />
      ) : isPremium && typeof showPremiumWebview === 'undefined' ? (
        <PremiumCarousel
          isWebview={isWebview}
          height={designTemplateRef.current?.style?.height || designHeight}
          designTemplateRef={designTemplateRef}
          preview={false}
          fabricArt={fabricArt}
          isViewInvitationPage={isViewInvitationPage}
          onCanPlayAnimation={onCanPlayAnimation}
        />
      ) : isFabric(event.origin) ? (
        <div
          className={cx(`view-invitation__fabric-free-template-wrapper`, {
            'view-invitation__fabric-free-template-wrapper--sidepanel': showSidePanel,
          })}
        >
          <Card fabricArt={fabricArt} isFree />
          {showSidePanel ? (
            <div className="view-invitation__side-panel">
              <GoogleAdBanner
                sidePanel
                index={SIDEPANEL_AD_ID}
                isCreateEditPreview={isCreateEditPreview}
                isGuestPreview={isGuestPreview}
                removeOnClick={() => toggleUpsellModal(true, 'remove-ads')}
                showRemoveButton={isHost || isHostViewing}
                location="rr"
              />
            </div>
          ) : null}
        </div>
      ) : isMediumAndUp ? (
        <>
          {template.css && <link rel="stylesheet" type="text/css" href={template.css} />}
          {template.customFonts &&
            template.customFonts.map((cf, index) => (
              <link rel="stylesheet" type="text/css" href={cf} key={`customFont_${index}`} />
            ))}
          <div id="invitation" ref={fitContainerRef}>
            <div className="wrapper">
              <div className="inner clearfix">
                <div className="bg_mid">
                  <div className="bg_top">
                    <div className="bg_bottom clearfix free-template-wrapper">
                      {/* Add custom logo here */}
                      {event.custom_logo && event.custom_logo.url && (
                        <CustomLogoImage
                          custom_logo={event.custom_logo}
                          layout="desktop"
                          zIndex={15}
                          clickable={false}
                        />
                      )}

                      <div id="event_image" style={eventImageStyle}>
                        {template.uyo && customImageURL && (
                          <img
                            id="main_image"
                            src={customImageURL}
                            style={{
                              background: `${event.main_image_background && 'grey'}`,
                            }}
                            alt=""
                          />
                        )}
                        <div className="main_image_mask" />
                      </div>
                      <div id="event_details">
                        <h1 className="event_title">
                          <span className="title" id="cover_title">
                            {event.title}
                          </span>
                        </h1>
                        <div className="event_info">
                          <ul className="host_phone">
                            <li className="host">
                              <strong className="host">Host:</strong>
                              <div>
                                <span className="hostname hostName" id="cover_host_name">
                                  {event.host_name}
                                </span>
                              </div>
                            </li>
                            <li className="phone">
                              <strong className="phone">Phone:</strong>
                              <div>
                                <span className="phoneNumber" id="cover_phone_number">
                                  {event.phone_number}
                                </span>
                              </div>
                            </li>
                          </ul>
                          <ul className="when_where">
                            <li className="time">
                              <strong className="when">When:</strong>
                              <div>
                                <span className="dateAndTime" id="cover_start_datetime">
                                  {startFormatted}
                                </span>
                                <span className="dateAndTimeEnd" id="cover_end_datetime">
                                  {endFormatted}
                                </span>
                              </div>
                            </li>
                            <li className="address">
                              <strong className="where">Where:</strong>
                              <div>
                                <span className="locationName" id="cover_location_name">
                                  {event.location_name}
                                </span>
                                <span className="streetAddress" id="cover_street_address">
                                  {event.street_address}
                                </span>
                                <span className="cityStateZipCountryLine" id="cover_city_zip">
                                  {cityAddressLine(event)}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {event.start_datetime &&
                      template.specialFeatures &&
                      template.specialFeatures.countdown ? (
                        <div id="special_features">
                          <FreeEventCountdown
                            startTime={convertToIso(window.evite_event?.start_datetime || '')}
                            countdown={template.specialFeatures.countdown}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="preload" />
          </div>
        </>
      ) : (
        <>
          <img src={design} alt="" className={isPremium ? '' : 'free'} />
          {/* Add custom logo here */}
          {showCustomLogo && logoHasBeenPaid && <CustomLogoImage {...logoImgProps} />}
          {template.specialFeatures &&
          template.specialFeatures.countdown &&
          event.start_datetime ? (
            <div id="special_features">
              <FreeEventCountdown
                startTime={convertToIso(event.start_datetime)}
                countdown={template.specialFeatures.countdown}
                mobile
                scale={window.innerWidth / 424.0}
              />
            </div>
          ) : null}
          {template.uyo && uyoImageElement}
          <div
            id="design-template"
            style={{
              position: 'absolute',
              bottom: '2.5%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <div id="event_details" ref={fitContainerRef}>
              <div id="event_text" className={lineCount < 6 ? 'extra_margins' : ''}>
                <p
                  id="cover_title"
                  className={`paragraph2 event_title${
                    event.title && event.title.length > 18 ? ' long' : ''
                  }`}
                  style={{
                    color: template.eventTitleColor,
                    fontSize: event.title.length > 18 && scale < 1.0 ? 24 * scale : 32 * scale,
                    lineHeight: '125%',
                    marginBottom: '1rem',
                  }}
                >
                  {event.title || 'Event Title'}
                </p>
                <div
                  className="event_info"
                  style={{
                    color: template.informationColor,
                    fontSize: 16 * scale,
                  }}
                >
                  <div className="event_time">
                    <Typography variant="paragraph2" data-qa-id="cover_start_datetime">
                      {startFormatted}
                    </Typography>
                    <Typography variant="paragraph2" data-qa-id="cover_end_datetime">
                      {endFormatted}
                    </Typography>
                  </div>
                  <br />
                  <Typography variant="paragraph2" data-qa-id id="cover_host_name">
                    {event.host_name || 'Bob Johnson'}
                  </Typography>
                  <Typography variant="paragraph2" id="cover_phone_number">
                    {event.phone_number}
                  </Typography>
                  <br />
                  <div className="address">
                    <Typography variant="paragraph2" data-qa-id="cover_location_name">
                      {event.location_name}
                    </Typography>
                    <Typography variant="paragraph2" data-qa-id="cover_street_address">
                      {event.street_address}
                    </Typography>
                    <Typography variant="paragraph2" data-qa-id="cover_city_zip">
                      {cityAddressLine(event)}
                    </Typography>
                  </div>
                </div>{' '}
              </div>
            </div>
            <div className="preload" />
          </div>
        </>
      )}
    </div>
  );
};

export const DesignTemplate = ({
  themeColor,
  showPremiumWebview,
  bgAlpha,
  isWebview = false,
  isViewInvitationPage,
  hideGoogleAd,
  onCanPlayAnimation,
  toggleUpsellModal,
}) => {
  const coverData = useSelector((state) => state.coverData, shallowEqual);
  const fabricArt = useSelector(
    (state) => state.eventDetails?.fabric_design_data ?? state.fabricDesign?.fabricArt
  );

  const isPremium = useSelector(
    (state) =>
      state.eventDetails.isPremium ||
      state.user.subscriptionPlanName === PLAN_NAME_PRO ||
      state.user.subscriptionPlanName === PLAN_NAME_PARTY_PASS
  );
  const eviteEvent = useSelector((state) => state.eviteEvent);
  const event = eviteEvent || window.evite_event;
  const {template} = coverData;
  const customImageURL = coverData.image_url;
  const bonusClassNames = 'reinvention';

  return (
    <ViewCoverMobile
      parent="reinvention"
      {...{
        event,
        template,
        showPremiumWebview,
        customImageURL,
        fabricArt,
        bonusClassNames,
        isPremium,
        themeColor,
        bgAlpha,
        isWebview,
        isViewInvitationPage,
        onCanPlayAnimation,
        hideGoogleAd,
        toggleUpsellModal,
      }}
    />
  );
};
